import * as React from 'react';
import PageLayout from 'global_elements/Layouts/PageLayout';
import { PageLayoutVariant } from 'global_elements/Layouts/PageLayout/variants';
import { useHistory } from 'react-router-dom';
import { ExecutiveRoutes } from 'constants/routes';

const CorporationDashboardPage = (): React.JSX.Element => {
  const history = useHistory();

  React.useEffect(() => {
    history.push(ExecutiveRoutes.REPORTS);
  }, []);

  return (
    <PageLayout layout={PageLayoutVariant.PADDED} testText="Corporation Dashboard Page" title="Corporation Dashboard">
      Redirecting...
    </PageLayout>
  );
};

export default CorporationDashboardPage;
